// extracted by mini-css-extract-plugin
module.exports = {"skeleton-image":"SkeletonImage_skeleton-image__s_M4D","hide-rank":"SkeletonImage_hide-rank__Zow9Y","inscription-info-wrap":"SkeletonImage_inscription-info-wrap__T_Z3k"};